const componentConfig = [
  {
    id: 'componentPassportId',
  },
  {
    id: 'supplierId',
    required: true,
  },
  {
    id: 'supplierName',
    required: true,
  },
  {
    id: 'componentName',
    required: true,
  },
  {
    id: 'componentId',
    required: true,
  },
  {
    id: 'itemId',
  },
  {
    id: 'batchNumber',
    required: true,
  },
  {
    id: 'countryOfOrigin',
    required: true,
  },
  {
    id: 'region',
  },
  {
    id: 'factory',
  },
  {
    id: 'percentShare',
    required: true,
    notDisableWhenLinked: true,
  },
  {
    id: 'percentRecycled',
    required: true,
  },
];

export { componentConfig };
